import type { SxProps, Theme } from '@mui/material';

export const accordionSummaryWrapper: SxProps<Theme> = {
  flexShrink: 0,
  display: 'flex',
  margin: '0 1rem',
  alignItems: 'center',
};
